import { PutObjectCommand, GetObjectCommand, DeleteObjectCommand } from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { s3Client, awsConfig } from '../config/aws';

/**
 * Upload image to S3
 */
export const uploadImageToS3 = async (
  file: File | Blob,
  userId: string,
  scanId: string
): Promise<string> => {
  try {
    const key = `scans/${userId}/${scanId}.jpg`;
    
    // Convert file to buffer
    const arrayBuffer = await file.arrayBuffer();
    const buffer = Buffer.from(arrayBuffer);
    
    await s3Client.send(new PutObjectCommand({
      Bucket: awsConfig.s3.bucket,
      Key: key,
      Body: buffer,
      ContentType: 'image/jpeg',
      Metadata: {
        userId,
        scanId,
        uploadedAt: new Date().toISOString(),
      },
    }));
    
    return key;
  } catch (error) {
    console.error('Error uploading to S3:', error);
    throw error;
  }
};

/**
 * Upload base64 image to S3
 */
export const uploadBase64ToS3 = async (
  base64Data: string,
  userId: string,
  scanId: string
): Promise<string> => {
  try {
    // Remove data:image/jpeg;base64, prefix if present
    const base64Image = base64Data.replace(/^data:image\/\w+;base64,/, '');
    const buffer = Buffer.from(base64Image, 'base64');
    
    const key = `scans/${userId}/${scanId}.jpg`;
    
    await s3Client.send(new PutObjectCommand({
      Bucket: awsConfig.s3.bucket,
      Key: key,
      Body: buffer,
      ContentType: 'image/jpeg',
      Metadata: {
        userId,
        scanId,
        uploadedAt: new Date().toISOString(),
      },
    }));
    
    return key;
  } catch (error) {
    console.error('Error uploading base64 to S3:', error);
    throw error;
  }
};

/**
 * Get signed URL for image (for viewing)
 */
export const getSignedImageUrl = async (key: string, expiresIn: number = 3600): Promise<string> => {
  try {
    const command = new GetObjectCommand({
      Bucket: awsConfig.s3.bucket,
      Key: key,
    });
    
    const url = await getSignedUrl(s3Client, command, { expiresIn });
    return url;
  } catch (error) {
    console.error('Error getting signed URL:', error);
    throw error;
  }
};

/**
 * Delete image from S3
 */
export const deleteImageFromS3 = async (key: string): Promise<void> => {
  try {
    await s3Client.send(new DeleteObjectCommand({
      Bucket: awsConfig.s3.bucket,
      Key: key,
    }));
  } catch (error) {
    console.error('Error deleting from S3:', error);
    throw error;
  }
};

/**
 * Generate unique scan ID
 */
export const generateScanId = (): string => {
  return `scan_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};


